define('TescoMobile_FreeGift/js/tooltip',['jquery', 'Magento_Catalog/js/price-utils'], function ($, priceUtils) {
  'use strict';

  const showTooltip = function (tooltipContainer, clubCardPoints, voucherValue) {
    if (!tooltipContainer.length || !clubCardPoints || !voucherValue) {
      return;
    }
    const tooltipClose = tooltipContainer.find('.close');
    const tooltipLink = tooltipContainer.find('.product-content__link');
    tooltipContainer.parent().css('position', 'relative');
    tooltipContainer.show();
    tooltipContainer.find('.clubcard-points-value').text(clubCardPoints);
    tooltipContainer.find('.voucher-value').text(priceUtils.formatPrice(voucherValue));
    tooltipLink.on('click', function (event) {
      event.preventDefault();
      const URL = event.target.dataset.href;
      const dataTarget = event.target.dataset.target;
      window.open(URL, dataTarget);
    });
    tooltipClose.on('click', function (event) {
      event.preventDefault();
      tooltipContainer.hide();
      tooltipClose.off('click');
    });
    tooltipContainer.on('click', function (event) {
      event.preventDefault();
    });
  };
  return function (config, element) {
    var _config$element;
    if (!(config !== null && config !== void 0 && config.element) && !element) {
      return;
    }
    const $element = $((_config$element = config === null || config === void 0 ? void 0 : config.element) !== null && _config$element !== void 0 ? _config$element : element);
    if (config !== null && config !== void 0 && config.useContainer) {
      $element.on('click', function (event) {
        var _$;
        if (!(config !== null && config !== void 0 && config.containerSelector)) {
          return;
        }
        const freeGiftWrapper = (_$ = $(event.target)) === null || _$ === void 0 ? void 0 : _$.parent().closest(config.containerSelector);
        if (!(freeGiftWrapper !== null && freeGiftWrapper !== void 0 && freeGiftWrapper.length)) {
          return;
        }
        const label = freeGiftWrapper.find('.free-gift.label');
        if (!(label !== null && label !== void 0 && label.length)) {
          return;
        }
        const clubCardPoints = label[0].getAttribute('data-clubcard-points');
        const voucherValue = label[0].getAttribute('data-voucher-value');
        event.preventDefault();
        showTooltip(freeGiftWrapper.next(), clubCardPoints, voucherValue);
      });
    } else {
      $element.on('click', function () {
        showTooltip($element.next(), config.clubCardPoints, config.voucherValue);
      });
    }
  };
});

